<template>
  <el-card class="login-form">
    <el-form :model="loginForm">
      <el-form-item label="用户名" prop="username">
        <el-input v-model="loginForm.username" :width="100" maxlength="15"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="loginForm.password" :width="100" maxlength="15"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="doLogin()">登录</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      loginForm: {
        username: "tentcoo",
        password: "ccadmin2020",
      },
    };
  },
  methods: {
    doLogin() {
      this.ccRequest
        .do("loginJson", this.loginForm)
        .then((res) => {})
        .catch((err) => {});
    },
  },
  mounted() {},
  created() {},
};
</script>

<style>
/* .login-form {
  width: 400px;
  height: 300px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -150px;
  margin-left: -200px;
} */
</style>
